module.exports = __webpack_public_path__ + "i18n/zh-TW.8322749677746bd2742e8b47ffa6cdb2.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=i18n/[name].[hash].[ext]!./i18n/zh-TW.json
// module id = 1316
// module chunks = 59